// extracted by mini-css-extract-plugin
export default {"topRatedBadge":"GuideRatingInfo_topRatedBadge__8O57r"};